import { IoChevronBackOutline, IoCloseOutline } from "react-icons/io5";
import "./ProductsOnlineShop.scss";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import { useEffect } from "react";

export const ProductOnlineShop = ({ products, onBackClick, onExitClick }) => {
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  useEffect(() => {
    trackEvent("webapp_user_visited_online_shop", uid);
  }, [uid, trackEvent]);

  return (
    <div className="product-online-shop-page">
      <img
        className="product-online-shop-background-image"
        src="images/curl-yellow.png"
        alt="Yellow Curl"
        width={100}
      />
      <div className="product-online-shop-top-container">
        <div className="product-online-shop-back-button-wrapper">
          <div className="back-icon" onClick={onBackClick}>
            <IoChevronBackOutline />
          </div>
        </div>
        <div className="product-online-shop-close-button-wrapper">
          <div className="close-icon" onClick={onExitClick}>
            <IoCloseOutline />
          </div>
        </div>
      </div>
      <h4 className="product-online-shop-title">Shop Your Picks!</h4>
      <div className="product-online-shop-products-wrapper">
        {products !== undefined &&
          products.recommendations.map((product, index) => (
            <div className="product-online-shop-item" key={index}>
              <div className="product-online-shop-top">
                <div className="product-online-shop-image-container">
                  <img
                    src={`data:image/png;base64, ${product.image}`}
                    alt={product.name}
                    className="product-online-shop-image"
                  />
                </div>
                <div className="product-online-right-container">
                  <p className="product-online-brand-text">{product.brand}</p>
                  <p className="product-online-name-text">{product.name}</p>
                  <button
                    className="product-online-shop-button"
                    onClick={() => {
                      const newWindow = window.open(
                        "https://clicks.co.za/searchProducts?query=The%20perfect%20hair",
                        "_blank",
                        "noopener,noreferrer",
                      );
                      if (newWindow) newWindow.opener = null;
                    }}
                  >
                    Buy at Clicks
                  </button>
                </div>
              </div>
              <h4 className="product-online-available-text">
                Also available at:
              </h4>
              <div className="product-online-shop-buttons">
                <button
                  className="product-online-shop-button"
                  onClick={() => {
                    const newWindow = window.open(
                      "https://www.dischem.co.za/catalogsearch/result/?q=the+perfect+hair&form_key=N8iIh2zvyO5slR2R",
                      "_blank",
                      "noopener,noreferrer",
                    );
                    if (newWindow) newWindow.opener = null;
                  }}
                >
                  Buy at Dischem
                </button>
                <button
                  className="product-online-shop-button"
                  onClick={() => {
                    const newWindow = window.open(
                      "https://www.takealot.com/all?_sb=1&_r=1&_si=3fa724a0996b19d3ff775f2d69b4d4f3&qsearch=the%20perfect%20hair",
                      "_blank",
                      "noopener,noreferrer",
                    );
                    if (newWindow) newWindow.opener = null;
                  }}
                >
                  Buy at Takelot
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
